import { render } from "./ThoughtInList.vue?vue&type=template&id=10509c7c&scoped=true&ts=true"
import script from "./ThoughtInList.vue?vue&type=script&lang=ts"
export * from "./ThoughtInList.vue?vue&type=script&lang=ts"

import "./ThoughtInList.vue?vue&type=style&index=0&id=10509c7c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10509c7c"]])

export default __exports__